var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecondTopper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4577 11.968V5.83447H10.791V11.968C12.0836 11.304 13.5583 10.925 15.1244 10.925C16.6905 10.925 18.1651 11.304 19.4577 11.968Z",
    fill: "#A0AEC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4577 1.5H10.791V4.75116H19.4577V1.5Z",
    fill: "#A0AEC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 12.0083C10.6454 12.0083 7 15.4858 7 19.7541C7 24.0279 10.6454 27.5 15.125 27.5C19.6046 27.5 23.25 24.0279 23.25 19.7541C23.25 15.4858 19.6046 12.0083 15.125 12.0083ZM19.35 25.55L15.125 23.405L10.9 25.55L11.7071 21.0054L8.26206 17.7716L13.0179 17.1L15.125 12.9887L17.2321 17.1L21.9879 17.7716L18.5429 21.0054L19.35 25.55Z",
    fill: "#A0AEC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondTopper);
export default __webpack_public_path__ + "static/media/SecondTopper.5f3ffb08d774e8830d15d5093a77622d.svg";
export { ForwardRef as ReactComponent };